<mat-dialog-content>
    <mat-card-title class="content-block">
        {{ baseTranslationKey + '.header' | translate : {ruleType: ruleTypeText} }}
    </mat-card-title>

    @if (ruleList.length > 0) {
        <mat-card-content class="content-block">
            <div class="editor-container">
                <mat-button-toggle-group
                    vertical class="rule-selector"
                    name="ruleToEdit"
                    aria-label="Rule to edit"
                    value="{{selectedRuleIndex}}">
                    @for (rule of ruleList; track rule; let i = $index) {
                        <mat-button-toggle
                            (click)="changeSelectedRule(i)"
                            value="{{i}}">
                            {{ rule.ruleId }}
                        </mat-button-toggle>
                    }
                </mat-button-toggle-group>
                <div class="rule-editor">
                    <label>{{ "updateRules." + ruleTypeText | translate }}</label>
                    <!-- We could also use something like CodeMirror or monaco editor, if we want nicer editors -->
                    <ngx-monaco-editor [options]="options"
                                       [(ngModel)]="ruleList[selectedRuleIndex].ruleCode"
                                       class="rule-editor"
                    ></ngx-monaco-editor>
                    @if (ruleTypeText !== 'event') {
                        <label>{{ 'updateRules.correction' | translate }}</label>
                    }
                    @if (ruleTypeText !== 'event') {
                        <ngx-monaco-editor
                            [options]="options"
                            [(ngModel)]="ruleList[selectedRuleIndex].correctionCode"
                            class="rule-editor"
                        ></ngx-monaco-editor>
                    }
                </div>
            </div>
        </mat-card-content>
    } @else {
        <mat-card-content class="content-block container">
            {{ baseTranslationKey + '.noRules' | translate : {ruleType: ruleTypeText} }}
        </mat-card-content>
    }

    <ng-template #noRules>
        <mat-card-content class="content-block container">
            {{ baseTranslationKey + '.noRules' | translate : {ruleType: ruleTypeText} }}
        </mat-card-content>
    </ng-template>

    @if (!readOnly) {
        <mat-card-actions class="button-div" [ngClass]="{'no-crud' : !crud}">
            <div class="crud-buttons">
                @if (crud) {
                    <app-button
                        class="add-rule-button"
                        [buttonType]="'secondary'"
                        [label]="'updateRules.add' | translate"
                        (click)="addRule()">
                    </app-button>
                }
                @if (crud && ruleList.length > 0) {
                    <app-button
                        class="delete-rule-button"
                        [buttonType]="'secondary'"
                        [label]="'updateRules.remove' | translate"
                        (click)="removeSelectedRule()"> <!-- TODO: Add confirmation? -->
                    </app-button>
                }
                @if (ruleList.length > 0 && showAdditional) {
                    <div class="rule-fields">
                        <app-button
                            class="delete-rule-button"
                            [buttonType]="'secondary'"
                            [label]="'updateRules.editFields' | translate"
                            (click)="openEditAdditionalValuesDialog($event, selectedRuleIndex)">
                        </app-button>
                    </div>
                }
            </div>
            <div class="button-div">
                <app-button
                    class="send-button"
                    [buttonType]="'primary'"
                    [label]="'updateRules.openDocs' | translate"
                    (click)="openDocs()">
                </app-button>
                <app-button
                    class="send-button"
                    [buttonType]="'primary'"
                    [label]="'updateRules.submit' | translate"
                    (click)="save()">
                </app-button>
            </div>
        </mat-card-actions>
    }

    @if (errorMessage?.length > 0) {
        <div class="error-container">
            <h2 class="error-header">{{ "updateRules.errorHeader" | translate }}</h2>
            <h3 class="error">{{ errorMessage }}</h3>
        </div>
    }
</mat-dialog-content>
